import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export const useConfirmEmailBySharingLinkMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: recallApi.ConfirmEmailBySharingLinkResponse) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async (token: string) => {
      const body = {
        token,
      };

      const response = await recallApi.confirmEmailBySharingLink({
        body,
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
